import { Route } from '@angular/router';
import { BuSelectionComponent } from './business-unit/bu-selection.component';
import { ApiRequestComponent } from './api-request/api-request.component';
import { LogoutComponent } from './authentication/logout.component';
import { UserBusinessUnitAuthGuard } from '../auth/auth-guard/user-business-unit.authguard';

export const AuthRoutes: Route[] = [
    { path: 'bu', component: BuSelectionComponent },
    { path: 'spa/bu', component: BuSelectionComponent },
    { path: 'logout', component: LogoutComponent },
    { path: 'apirequest', component: ApiRequestComponent, canActivate: [UserBusinessUnitAuthGuard] }
];
